import Vue from 'vue'
import Router from 'vue-router'
import { isWapClient } from '@/utils/platform'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const pcViews = {
  cloudHome: () => import('@/views/pc/CloudHome'),
  login: () => import('@/views/pc/Login'),
  fileShared: () => import('@/views/pc/FileShared'),
  sharedList: () => import('@/views/pc/SharedList'),
  notFound: () => import('@/views/pc/vitransfer')
}

const wapViews = {
  cloudHome: () => import('@/views/wap/CloudHome'),
  login: () => import('@/views/wap/Login'),
  fileShared: () => import('@/views/wap/FileShared'),
  sharedList: () => import('@/views/wap/SharedList'),
  notFound: () => import('@/views/wap/vitransfer')
}

const views = isWapClient() ? wapViews : pcViews

export default new Router({
  mode: 'history',
  routes: [
    {
      name:'vitransfer',
      path: '/',
      meta:{title:'viwoods'},
      component: views.cloudHome
    },
    {
      path: '/vitransfer',
      redirect: to => ({ path: '/', query: to.query, hash: to.hash }),
    },
    {
      name:"login",
      path: '/login',
      meta:{title:'viwoods'},
      component: views.login
    },
    {
      path: '/vitransfer/login',
      redirect: to => ({ path: '/login', query: to.query, hash: to.hash }),
    },
    {
      name:'fileshared',
      path: '/shared/s/:key',
      meta:{title:'viwoods'},
      component: views.fileShared
    },
    {
      name:'sharedlist',
      path: '/shared/list',
      meta:{title:'viwoods'},
      component: views.sharedList
    },
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/404',
      meta:{title:'viwoods'},
      component: views.notFound
    }
  ]
})
